var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all:flex"},_vm._l((_vm.iteration),function(n){return _c('span',{key:n,class:`bg-${_vm.colour}`,style:([{ '--n': n }, { '--total': _vm.iteration }])})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }